/*
 * @Author: 陈浩彬
 * @Date: 2021-09-07 15:15:36
 * @LastEditTime: 2021-09-13 14:37:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \logistics-fe-otp\src\modules\otp\api\algorithmParameters.js
 */
import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (data) => {
    return request({
        url: `/api-tms/lineHeaders`,
        method: 'post',
        data
    });
};
// 详情订单查询
export const getOrderList = (data) => {
    return request({
        url: `/api-tms/lineOrders`,
        method: 'post',
        data
    });
};
// 详情车次查询
export const getLineList = (data) => {
    return request({
        url: `/api-tms/lineDetails`,
        method: 'post',
        data
    });
};
